/** LEGO Star Wars: The Complete Saga portraits developers choose their profile picture from. */
import catalogue from '@schemas/lego_avatars.json'

export interface LegoCharacter { id: string; name: string; reserved?: boolean }

export const LEGO_CHARACTERS: LegoCharacter[] = catalogue.characters

/** What developers may choose: the battle droids are reserved for internal tools and services. */
export const PICKABLE_LEGO_CHARACTERS = LEGO_CHARACTERS.filter(c => !c.reserved)

export const legoAvatarUrl = (id: string) => `/avatars/lego/${id}.webp`
